const {
  AMPLITUDE_API_KEYS: AMPLITUDE_API_KEYS_MEP_PRD
} = require("../../utils/mep/amplitude");
const {
  AMPLITUDE_API_KEYS: AMPLITUDE_API_KEYS_TVG4_PRD
} = require("../../utils/tvg4/amplitude");

module.exports = {
  service_host: "service.tvg.com",
  domain: {
    desktop: "www.tvg.com",
    mobile: "www.tvg.com",
    talentPicks: "www.tvg.com/talent-picks/",
    equibase: "equibase-store.tvg.com"
  },
  externalDomain: {
    support: "https://support.tvg.com",
    contactSupport:
      "https://support.tvg.com/tvg/s/articles/360005946853-Contact-Support",
    NCPGamblingChat: "http://www.ncpgambling.org/chat"
  },
  google: {
    tvg4: {
      gtmId: "KTDSBG",

      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "desktop",
      productVersion: "TVG4"
    },
    tvg5: {
      gtmId: "KTDSBG",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "desktop",
      productVersion: "TVG5"
    },
    touch2: {
      gtmId: "KTDSBG",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "mobile_web",
      productVersion: "MEP"
    },
    ios: {
      gtmId: "KTDSBG",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "ios_native"
    },
    touch3: {
      gtmId: "KTDSBG",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "mobile_web",
      productVersion: "MEP"
    },
    ios2: {
      gtmId: "KTDSBG",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "ios_native"
    },
    fdrdesktop: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "desktop",
      productVersion: "URP"
    },
    fdrmobile: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "mobile_web",
      productVersion: "MEP"
    },
    fdrios: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "ios_native",
      productVersion: "MEP"
    },
    fdrandroid: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "android_native",
      productVersion: "android_apk"
    },
    fdrandroidwrapper: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "android_native",
      productVersion: "android_apk"
    },
    fdrandroidgps: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "android_native",
      productVersion: "android_apk"
    },
    fdriosxsell: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "x-sell",
      productVersion: "MEP"
    },
    fdrandroidxsell: {
      gtmId: "NSHBQSR",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "x-sell",
      productVersion: "android_apk"
    },
    androidwrapper: {
      gtmId: "KTDSBG",

      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "android_native",
      productVersion: "android_gps"
    },
    tvgandroid: {
      gtmId: "KTDSBG",

      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "android_native",
      productVersion: "android_apk"
    },
    iosnative: {
      gtmId: "KTDSBG",
      gtmEnv: "",
      gtmAuth: "",
      siteVersion: "ios_native",
      productVersion: "ios_native"
    },
    gcs: {
      url: "https://storage.googleapis.com",
      tvgStatic: "tvg-static"
    }
  },
  amplitude: {
    touch3: {
      amplitudeAPI: AMPLITUDE_API_KEYS_MEP_PRD.PRODUCTION,
      siteVersion: "mobile_web",
      sitePlatform: "mobile_web",
      product: "tvg_mep"
    },
    androidwrapper: {
      amplitudeAPI: AMPLITUDE_API_KEYS_MEP_PRD.PRODUCTION,
      siteVersion: "native",
      sitePlatform: "android",
      product: "tvg_mep",
      androidDistributionMethod: "self_dist"
    },
    tvgandroid: {
      amplitudeAPI: AMPLITUDE_API_KEYS_MEP_PRD.PRODUCTION,
      siteVersion: "native",
      sitePlatform: "android",
      product: "tvg_mep",
      androidDistributionMethod: "self_dist"
    },
    tvg4: {
      amplitudeAPI: AMPLITUDE_API_KEYS_TVG4_PRD.PRODUCTION,
      siteVersion: "desktop",
      sitePlatform: "desktop",
      product: "tvg_tvg4"
    }
  },
  brazeId: "908c5857-650b-4f31-8ec7-63b15dc11d1d",
  siftAccountId: "60f88a09293fb116c8220750",
  siftBeaconKey: "df80113946",
  clientId: "eaf77f127ea003d4e275a3ed07d6f527",
  perimeterxId: "TK74ox9H",
  storyblokToken: "mBZqhnrYeUYWqvVh3OTCDgtt",
  storyblokVersion: "published",
  placesAPI: "AIzaSyC5ndZZINgQFlsdFROtRPAw3nYG_g8_jzw",
  paypalID:
    "AfOWmRjlT73hGanCAUypmRtFas_NsPcXek2_fL8XOIrJHBDoUxcSEVBQ72Ls4fc_2xgJSWK3gTDrgjhI",
  apptentiveID: "61f087a65a8827645c000039",
  apptentiveTvg5: "62041fcb5a88277d4900018f",
  apptentiveIosKey: "IOS-TVG-HORSE-RACING-BETTING-APP",
  apptentiveIosSignature: "c0b078503398c5fec509b1235058c955",
  apptentiveAndroidKey: "ANDROID-TVG-PRODUCTION",
  apptentiveAndroidSignature: "b09205fa5b98d7fdc161f1ca98b5d9b1",
  sonarQube: {
    serverUrl: "https://sonarqube.gcp-dev.tvg.com",
    token: "8836caf742bb1c13755da2d957ba5d1674adbc43",
    projectKey: "tvg-monorepo"
  },
  datadogRum: {
    desktopApplicationId: "123b949b-108c-4306-bea0-9227242f5b17",
    desktopClientToken: "pub748e107dd1bd28256dad4b1425dda2e3",
    mobileApplicationId: "03715ae6-b7e2-4b30-ac7b-cf6a5bfdf763",
    mobileClientToken: "pub333a7706c3a954d17d9db1becba22673",
    fdrApplicationId: "c15f8a9f-f7a7-4108-97f3-9e81d2e936fb",
    fdrClientToken: "pubf5bbdc9d5e227feae77a9ad9f5e1013a",
    site: "datadoghq.com"
  },
  externalServices: {
    cpp: "https://promos-api.racing.fanduel.com"
  }
};
